<template>
<div>

    <section id="expositores">
        <div class="container-lg">


            <div v-for="(patrocinadores, tipo) in filteredResults" :key="tipo">

                <div class="row justify-content-center">
                    <div class="col-12">
                        <h3 class="text-center">{{tipo}}</h3>
                    </div>
                </div>
                <div class="logo-grid" :class="tipo|lowerCase">

                    <div v-for="(patrocinador, index) in patrocinadores" :key="index" :id="'patrocinador-id-'+patrocinador.partner.id" class="single-patrocinador text-center">
                        <a :title="patrocinador.partner.title" :href="patrocinador.partner.link" target="_blank" rel="nofollow  noopener"><img width="100" loading="lazy" :src="logoPath+'/150x86/'+patrocinador.partner.logo" class="company-info-img img-fluid" :title="patrocinador.partner.description" :alt="patrocinador.partner.name" v-b-tooltip.hover></a>
                        
                    </div>

                </div>

            </div> <!-- v-loop -->

        </div>
    </section>


    <footer id="main-footer">
        <section id="rodape">
            <div class="container">
                <div class="d-flex flex-footer justify-content-between">
                    <div class="realizacao col">
                        <p>Realização:</p>
                        <p>
                         <a href="http://ecbr.io/portal" target="_blank" rel=" noopener"> <img style="width: 200px;" src="https://www.ecommercebrasil.com.br/wp-content/themes/ecommercebrasil-2016/assets/images/ecbr-fe.svg" class="img-fluid" loading="lazy" alt="Logo E-commerce Brasil"></a>
                        </p>
                    </div>
                    <div class="midias text-center col" >
                        <p>Nos siga nas redes sociais:</p>
                        <ul class="d-flex justify-content-center">
                            <li><a href="https://www.facebook.com/EcommerceBrasil" rel="nofollow  noopener" target="_blank"><img src="https://eventos2.ecommercebrasil.com.br/forum/wp-content/themes/ecb-forum-2022/images/icons/icon-fb.svg" alt="Ícone Facebook" loading="lazy"></a></li>
                            <li><a href="https://twitter.com/ecommerce_br?lang=en" rel="nofollow  noopener" target="_blank"><img src="https://eventos2.ecommercebrasil.com.br/forum/wp-content/themes/ecb-forum-2022/images/icons/icon-twitter.svg" alt="Ícone Twitter" loading="lazy"></a></li>
                            <li><a href="https://www.linkedin.com/company/e-commerce-brasil/" rel="nofollow  noopener" target="_blank"><img src="https://eventos2.ecommercebrasil.com.br/forum/wp-content/themes/ecb-forum-2022/images/icons/icon-linkedin.svg" alt="Ícone Linkedin" loading="lazy"></a></li>
                            <li><a href="https://www.youtube.com/user/ecommercebrasil?sub_confirmation=1" rel="nofollow  noopener" target="_blank"><img src="https://eventos2.ecommercebrasil.com.br/forum/wp-content/themes/ecb-forum-2022/images/icons/icon-youtube.svg" alt="Ícone Youtube" loading="lazy"></a></li>
                            <li><a href="https://www.instagram.com/ecommerce_br/" rel="nofollow  noopener" target="_blank"><img src="https://eventos2.ecommercebrasil.com.br/forum/wp-content/themes/ecb-forum-2022/images/icons/icon-instagram.svg" alt="Ícone Instagram" loading="lazy"></a></li>
                        </ul>
                    </div>
                    <div class="contato text-end col">
                        <p>eventos@ecommercebrasil.com.br</p>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="maker flex-fill">
                        <a href="https://diti.site/" target="_blank" rel="noopener">SEO, CRO e Coordenação: <img src="https://eventos2.ecommercebrasil.com.br/forum/wp-content/themes/ecb-forum-2022/images/logo-agencia-diti-performance-lean-ux.webp" alt="Agência Diti - Performance, Lean, UX" width="30" height="25"></a>
                    </div>
                </div>
          </div>
        </section>
    </footer>
</div>

</template>
<script>

    import axios from 'axios'

    
    export default{
        data() {
          return {
            endpoint_patrocinadores: process.env.VUE_APP_ENDPOINT+'/expositores',
            patrocinadoresLista: [],
            logoPath: 'https://static.ecommercebrasil.com.br/central/partners/logos',
            filterResults: {
                "Oferecimento": [9,10],
                "Patrocinadores": [11,12,14],
                "Startups": [13],
                "Parceiros": [15]
            },
            filteredResults: {}

          }
        },
        created() {
            this.getPatrocinadores();
        },
        methods: {
            getPatrocinadores() {
                let vm = this;
                axios
                    .get(this.endpoint_patrocinadores)
                    .then(function(result) {
                        vm.patrocinadoresLista = result.data;
                        vm.filterPatrocinadores();
                    })
                    .catch(function (error) {
                      console.log(error);
                    });
            },

            filterPatrocinadores() {
                let vm = this;
                let listResults = [];

                for (var tipo in this.filterResults) {
                    listResults = this.patrocinadoresLista.singleExhibitors.filter(function(patrocinador) {
                        return ('eventData' in patrocinador.partner && 
                                patrocinador.partner.eventData != null && 
                                !patrocinador.partner.eventData.hide_footer) && 
                               vm.filterResults[tipo].includes(patrocinador.booths[0].sponsorship_quota_id)
                    });
                    this.$set(this.filteredResults, tipo, listResults)
                }
                console.log(this.filteredResults);
            }

        },
        computed: {
            getFilteredResults() {
                return this.filteredResults;
            }
        },
        filters:{
            lowerCase : function(data){
                let lower = []
                data.split(' ').forEach(word => {
                    lower.push(word.toLowerCase())
                })
                return lower.join(' ')
            }
        }


    }
</script>

<style>

</style>
